import { render, staticRenderFns } from "./PricingSheet.vue?vue&type=template&id=0b6ff52c&scoped=true"
import script from "./PricingSheet.vue?vue&type=script&lang=js"
export * from "./PricingSheet.vue?vue&type=script&lang=js"
import style0 from "./PricingSheet.vue?vue&type=style&index=0&id=0b6ff52c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ff52c",
  null
  
)

export default component.exports